import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    testid: "cpmc-manifesto-chapter-1",
    title: "Qu'est-ce que la Médecine Personnelle ?",
    accent: "bg-mint",
    body: "C'est ce que nous FAISONS pour aller mieux et le rester : cela nous permet de retrouver notre pouvoir d'agir. Une approche fondée sur des données probantes, qui augmente l'activation et mène à de meilleurs résultats de santé.",
  },
  {
    n: "02",
    testid: "cpmc-manifesto-chapter-2",
    title: "Qui est le coach CPMC ?",
    accent: "bg-sun",
    body: "Un expert de l'accompagnement qui aide chaque personne à découvrir et utiliser sa Médecine Personnelle dans son rétablissement. Le coach CPMC ne conseille jamais de commencer, cesser ou modifier un médicament prescrit — il soutient le pouvoir d'agir, pas la prescription.",
  },
  {
    n: "03",
    testid: "cpmc-manifesto-chapter-3",
    title: "À qui s'adresse la certification ?",
    accent: "bg-coral",
    body: "Aux pairs aidants, cliniciens, ergothérapeutes, gestionnaires de cas, intervenants psychosociaux, conseillers, psychologues et proches aidants. La formation répond aux critères de la SAMHSA pour les pratiques axées sur le rétablissement et les compétences de base du soutien par les pairs.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifeste" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="space-y-0 border-t border-ink/10">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              data-testid={c.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group grid gap-6 border-b border-ink/10 py-12 transition-colors duration-500 hover:bg-white/60 md:grid-cols-[120px_1fr_1.2fr] md:items-start md:gap-10 md:px-6"
            >
              <span className="font-display text-5xl font-extrabold text-ink/15 transition-colors duration-500 group-hover:text-ink/40 lg:text-6xl">
                {c.n}
              </span>
              <h2 className="font-display text-2xl font-bold leading-snug tracking-tight sm:text-3xl">
                <span className={`mr-3 inline-block h-3 w-3 rounded-full ${c.accent}`} />
                {c.title}
              </h2>
              <p className="max-w-prose text-base leading-relaxed text-ink/70 sm:text-lg">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
